// React
import React from 'react';

// Components
import { Loan } from '@mobilitystore/components-interface';

// Constants
import idConstants from '../../data/idConstants';

// Utils
import { getEnvironment } from '../../utils';

// CSS
import './index.scss';

const Loans = () => {
  return (
    <div className='mps-loans'>
      <Loan
        token={localStorage.getItem(idConstants.tokens.aaaIdToken)}
        environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        tenantId={process.env.REACT_APP_SELLER_TENANT_ID}
      />
    </div>
  );
};

export default Loans;
